import { ReactComponent as ArrowDown } from './arrow-down.svg';

export const RevisionDialogIcon = {
  ArrowDown,
};
